import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { ExaminationModel } from 'src/app/models/ExaminationModel';
import { ExaminationService } from 'src/app/services/ExaminationService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-examinationsearch',
  templateUrl: './examinationsearch.component.html',
  styleUrls: ['./examinationsearch.component.css']
})
export class ExaminationsearchComponent implements OnInit {
  patintname = '';
  bloodSugarFasting= '';
  bloodSugarRandom= '';
  cBcHgb= '';
  cBcMcH= '';
  cBcMcV= '';
  cBcPlT= '';
  cBcTlc= '';
  compcode= '1';
  dateentry= formatDate(new Date(), 'yyyy-MM-dd', 'en');
  diftBaso= '';
  difteosino= '';
  diftlym= '';
  diftMono= '';
  diftNeu= '';
  electroca1= '';
  electroca2= '';
  electroeSR1hr= '';
  electroeSR2hr= '';
  electrok= '';
  electroNa= '';
  kFTScrea= '';
  kFTUrea= '';
  kFTUricAcid= '';
  lFTAlB= '';
  lFTAlkPH= '';
  lFTAlT_SGPT= '';
  lFTAST_SGoT= '';
  lFTdBill= '';
  lFTGGT= '';
  lFTINR= '';
  lFTldH= '';
  lFTPc= '';
  lFTPT= '';
  lFTTBill= '';
  modifieddate= formatDate(new Date(), 'yyyy-MM-dd', 'en');
  other1= '';
  other2= '';
  other3= '';
  other4= '';
  other5= '';
  other6= '';
  other7= '';
  other8= '';
  other9= '';
  patientcode= '';
  tMarkersAFP= '';
  tMarkerscA12_5= '';
  tMarkerscA15_3= '';
  tMarkerscA19_9= '';
  tMarkersceA= '';
  tMarkersPSA= '';
  userId= '';
  paName ='';
  compCode = '1';
  examinationList: ExaminationModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();

  constructor(
              public dialogRef: MatDialogRef<ExaminationsearchComponent>,   ///----------- for searching pop up -----------
              public examinitionService: ExaminationService,
              public examination: ExaminationModel,
              public storage: LocalStorageService,
              @Inject(MAT_DIALOG_DATA)                                  ///----------- for searching pop up -----------
              public examinationSelectedData: ExaminationModel) { }

  ngOnInit(): void {this.retriveExaminationLookupTop_Patient()
  }
 
   public retriveExaminationLookupTop_Patient() {
    this.examinationList = [];
    this.examinitionService.getExaminitionLookup_Patient(this.storage.retrieve('stgPaID'),this.storage.retrieve('stgcompCode')).subscribe((data: ExaminationModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.examinationList[i] = data[i];
        data[i].dateentry = formatDate(data[i].dateentry, 'yyyy-MM-dd', 'en')
      }
      console.log(data);
    })
  }

  SelectExaminition(exam: ExaminationModel){                              ///----------- for searching pop up send variables from table-----------

    this.examinationSelectedData.patientcode = exam.patientcode
    this.examinationSelectedData.paName = exam.paName
    this.examinationSelectedData.dateentry = formatDate(exam.dateentry, 'yyyy-MM-dd', 'en');

    this.examinationSelectedData.bloodSugarFasting = exam.bloodSugarFasting
    this.examinationSelectedData.bloodSugarRandom = exam.bloodSugarRandom
    this.examinationSelectedData.cBcHgb = exam.cBcHgb
    this.examinationSelectedData.cBcMcH = exam.cBcMcH

    this.examinationSelectedData.cBcMcV = exam.cBcMcV
    this.examinationSelectedData.cBcPlT = exam.cBcPlT
    this.examinationSelectedData.cBcTlc = exam.cBcTlc

    this.submitClicked.emit(this.examinationSelectedData);
    console.log("------------ : " , this.examinationSelectedData.dateentry);
    this.dialogRef.close();

  }
}
